(() => {
  const FOOTER_EARLY_PX = 1200;  // bigger = collapses earlier
  const TOP_TRIGGER_PX  = 120;   // expands again only near top

  const html = document.documentElement;
  const overlay = document.querySelector('.penta-overlay-logos');
  if (!overlay) return;

  const topWrap = overlay.querySelector('.penta-overlay-word--top');
  if (!topWrap) return;

  // Prevent Baseline from switching header colors/state on first scroll
  html.classList.add('penta-overlay--lockheader');

  let isCollapsed = false;

  function getFooter() {
    return document.querySelector('#shopify-section-footer')
      || document.querySelector('footer')
      || document.querySelector('.footer');
  }

  function nearTop() {
    return (window.scrollY || window.pageYOffset || 0) <= TOP_TRIGGER_PX;
  }

  // Compute Y so the *scaled* logo sits exactly at --penta-collapse-top and stays centered
function computeYToCollapsedTopScaled() {
  const s = topWrap.getBoundingClientRect();
  const styles = getComputedStyle(document.documentElement);

  const scale = parseFloat(styles.getPropertyValue('--penta-collapse-scale')) || 0.30;

  // Target the visible nav row (penta custom nav first, then legacy row)
  const row = (() => {
    // Desktop: penta custom nav row
    const penta = document.querySelector('.penta-nav-desktop__row');
    if (penta) {
      const pr = penta.getBoundingClientRect();
      if (pr.height > 0 && pr.width > 0) return penta;
    }
    // Mobile: penta mobile top bar
    const mobile = document.querySelector('.penta-mobile-topbar');
    if (mobile) {
      const mr = mobile.getBoundingClientRect();
      if (mr.height > 0 && mr.width > 0) return mobile;
    }
    // Legacy desktop nav row
    const legacy = document.querySelector('.lg\\:relative.section-x-padding.flex.items-center.justify-between.py-2');
    if (legacy) {
      const lr = legacy.getBoundingClientRect();
      if (lr.height > 0 && lr.width > 0) return legacy;
    }
    // Fallback: any fixed header element with real height
    for (const sel of ['.header-wrapper', '#shopify-section-header', 'header']) {
      const el = document.querySelector(sel);
      if (el) {
        const er = el.getBoundingClientRect();
        if (er.height > 0) return el;
      }
    }
    return null;
  })();

  if (!row) return;

  const r = row.getBoundingClientRect();

  const startCy  = s.top + s.height / 2;

  // target = center of the header row (true vertical centering)
  const targetCy = (r.top + r.height / 2);

  // (optional tiny tweak if you want it optically a hair higher/lower)
  // const targetCy = (r.top + r.height / 2) + 1;

  html.style.setProperty('--penta-to-y', `${targetCy - startCy}px`);
}

let animating = false;

// Measure the actual header logo and set --penta-collapse-scale so the
// collapsed overlay matches it exactly (avoids visible size jump on swap).
function computeCollapseScale() {
  const img = topWrap.querySelector('.penta-overlay-word__img--light')
    || topWrap.querySelector('.penta-overlay-word__img');
  if (!img) return;

  // Find the first logo img that is actually in the layout (skip display:none ancestors)
  let logoImg = null;
  const candidates = document.querySelectorAll('header a.logo-image img:not([aria-hidden="true"])');
  for (const candidate of candidates) {
    if (candidate.getBoundingClientRect().width > 0) {
      logoImg = candidate;
      break;
    }
  }
  if (!logoImg) return;

  const overlayW = img.getBoundingClientRect().width;
  const logoW    = logoImg.getBoundingClientRect().width;

  if (overlayW > 0 && logoW > 0) {
    html.style.setProperty('--penta-collapse-scale', (logoW / overlayW).toFixed(4));
  }
}

function collapse() {
  if (isCollapsed || animating) return;
  animating = true;

  computeCollapseScale();
  computeYToCollapsedTopScaled();

  // start the logo move
  html.classList.add('penta-overlay--collapse');

  // IMPORTANT: keep lockheader ON during the animation
  // (prevents Baseline from painting white)
  // html.classList.remove('penta-overlay--lockheader');  <-- remove this line

window.setTimeout(() => {
  requestAnimationFrame(() => requestAnimationFrame(() => {
    html.classList.add('penta-overlay--navready');
  }));
  isCollapsed = true;
  animating = false;
}, 1250);

}

function expand() {
  if (!isCollapsed || animating) return;
  animating = true;

  // Lock header immediately so it doesn't flash to a different state
  html.classList.add('penta-overlay--lockheader');

  // Turn off nav+blur immediately (so it doesn't linger while logo expands)
  html.classList.remove('penta-overlay--navready');

  // expand the overlay
  html.classList.remove('penta-overlay--collapse');

  window.setTimeout(() => {
    isCollapsed = false;
    animating = false;
  }, 950);
}


function init() {
    const onScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset || 0;
      if (!isCollapsed && scrollY > 0) collapse();
      if (isCollapsed && nearTop()) expand();
    };
    const onResize = () => {
      computeCollapseScale();
      if (isCollapsed) computeYToCollapsedTopScaled();
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }



function setAnnouncementOffset() {
  // Target the bar element itself — the section wrapper has zero height when bar is position:fixed
  const bar =
    document.querySelector('.penta-announcement') ||
    document.querySelector('.announcement-bar-section') ||
    document.querySelector('#shopify-section-announcement-bar') ||
    document.querySelector('[data-section-type="announcement-bar"]');

  const h = bar ? Math.ceil(bar.getBoundingClientRect().height) : 0;
  document.documentElement.style.setProperty('--penta-announcement-h', `${h}px`);
}

window.addEventListener('resize', setAnnouncementOffset, { passive: true });
document.addEventListener('DOMContentLoaded', setAnnouncementOffset);
setAnnouncementOffset();



})();
